export default {"src":"/login-app/[GIT_HASH]/_next/static/media/download.9d0ca03b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};